import React from 'react'
import { Redirect, Route } from 'react-router-dom'


export const PrivateRoute = ({ component: Component, isLogin, ...rest }) => (
  <Route
    { ...rest }
    render = {props =>(
      isLogin ? <Component { ...props }/> : <Redirect to="/login"/>
    )}
  />
)
